import Radio from "../Radio";

/**
 * 
 */
export class Timer {
    constructor (callback, msDelay, scope, options={}) {
        this._callback = callback;
        this._msDelay = msDelay;
        this._scope = scope;
        this._document = options.document || document;
        this._ms = 0;

        this._onTick = this._onTick.bind(this);

        Radio.tuneIn(this._document, "tick", this._onTick);
    }

    _onTick (e) {
        this._ms += e.detail.delta;

        if (this._ms * 1000 >= this._msDelay) {
            Radio.tuneOut(this._document, "tick", this._onTick);

            if (this._scope) {
                this._callback.apply(this._scope);
            } else {
                this._callback();
            }
        }
    }

    clear () {
        Radio.tuneOut(this._document, "tick", this._onTick);
    }
}


/** WEBPACK FOOTER **
 ** ./src/util/timer.js
 **/